export default "__VITE_ASSET__BnTJa_Jn__"